<template>
    <div class="quiz-view">
        <QuizHeader />

        <div class="quiz-view-body">
            <Quiz :quiz_data=quiz_data />
        </div>
    </div>
</template>

<script>
import Quiz from '@/components/Quiz';
import QuizHeader from "@/components/QuizHeader";

export default {
    name: "QuizPage",
    components: {
        QuizHeader,
        Quiz
    },
    data() {
        return {
            quiz_data: require('@/json/quiz.json')
        }
    }
}
</script>

<style scoped lang="stylus">
.quiz-view {
    display: flex;
    flex-direction: column;
    flex: 1;
}

.quiz-view-body {
    display: flex;
    flex: 1;
}
</style>